import getMuiTheme from 'material-ui/styles/getMuiTheme';
import * as colors from 'material-ui/styles/colors';

const themeDefault = getMuiTheme({
  palette: {
    primary1Color: colors.blue500,
    primary2Color: colors.blue700,
    pickerHeaderColor: colors.blue500,
  },
  appBar: {
    height: 57,
    color: colors.blue600
  },
  drawer: {
    width: 230,
    // color: grey900
  },
  raisedButton: {
    primaryColor: colors.blue600,
  }
});

export const devThemeDefault = getMuiTheme({
  palette: {
    primary1Color: colors.pink500,
    primary2Color: colors.pink700,
    pickerHeaderColor: colors.pink500,
  },
  appBar: {
    height: 57,
    color: colors.pink600
  },
  drawer: {
    width: 230,
    // color: grey900
  },
  raisedButton: {
    primaryColor: colors.pink600,
  }
});

export default themeDefault;


// WEBPACK FOOTER //
// ./src/theme-default.js